import React, { useCallback, useContext } from 'react';
import CreateDataRoomContext from './CreateDataRoom.context';
import CreateNewDataRoomModal from 'components/CreateNewDataRoomModal';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

type CreateDataRoomProps = Record<string, any>;

const CreateDataRoom: React.FC<CreateDataRoomProps> = (props) => {
  const { children } = props;

  const [createDataRoomModal, createDataRoomModalRef] =
    useCallbackRef<ModalRef>();

  const { isRWCMember } = useContext(CurrentUserContext);

  const openCreateDataRoomModal = useCallback(
    () => createDataRoomModal?.open(),
    [createDataRoomModal],
  );

  return (
    <CreateDataRoomContext.Provider value={{ openCreateDataRoomModal }}>
      {children}
      {isRWCMember && <CreateNewDataRoomModal ref={createDataRoomModalRef} />}
    </CreateDataRoomContext.Provider>
  );
};

export default CreateDataRoom;
